import React from 'react';
import { connect } from 'react-redux';

import CurrencyFormat from '@scripts/utilities/currency.js';

import { fetch as fetchAssets, isAssetsLoading, getAssetById } from '../../../Store/assets.js';
import { fetch as fetchPortfolio, isPortfolioLoading, getPortfolioAssets } from '../../../Store/portfolio.js';


class PortfolioTotals extends React.Component {
  componentDidMount() {
    this.props.fetch();
  }

  render() {
    let content = null;

    if (! this.props.loading) {
      if (typeof this.props.total === 'number') {
        content = (
          <p className="text-right">
            <strong>
              Portfolio Total Value {CurrencyFormat(this.props.total)} (USD)
            </strong>
          </p>
        );
      }
    }


    return content;
  }
}


var mapStateToProps = function(state, ownProps) {
  let total = 0;
  
  const portfolios = getPortfolioAssets(state);
  for (var i = 0; i < portfolios.length; i++) {
    if(portfolios[i]?.portfolioId !== ownProps.portfolioId) {
      continue;
    }

    const asset = getAssetById(state, portfolios[i].asset);
    if (asset) {
      total += (asset.price * portfolios[i].quantity);
    }
  }

  return {
    loading: isAssetsLoading(state) || isPortfolioLoading(state),
    total: total
  };
};

var mapDispatchToProps = function(dispatch, ownProps) {
  return {
    fetch: function() {
      dispatch(fetchAssets());
      dispatch(fetchPortfolio());
    }
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(PortfolioTotals);

